// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../_metronic/_partials/controls";
import { useSelector } from "react-redux";

const CustomerEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is necesssary"),
  last_name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is necesssary"),
  email: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is necesssary"),
  phone: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Field is necesssary"),

  password: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols"),
  confirm_password: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols"),
});
/* const AVAILABLE_LOCATIONS = ["--null--", "Arizona", "Texas"]; */
export function ClientEditForm({
  update,
  client,
  actionsLoading,
  handleClose,
}) {
  const { user } = useSelector(state => state.auth);
  const userDocument = user.uid ? user : user.payload
  const [isSubmitting, setSubmitting] = useState(false)

  const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  return (
    <>
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize={true}
        initialValues={client}
        validationSchema={CustomerEditSchema}
        onSubmit={(values) => {
          update({ ...client, ...values, company_id: userDocument.company_id })
            .then(() => setSubmitting(false))
            .end((err) => {
              setSubmitting(false)
            })
        }}
      >
        {({ handleSubmit, handleChange, errors }) => (
          <>
            <Modal.Body className="  cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  {/* First Name */}
                  <div className="col-lg-4">
                    <Field
                      name="name"
                      component={Input}
                      placeholder="First Name"
                      label="First Name"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  {/* Last Name */}
                  <div className="col-lg-4">
                    <Field
                      name="last_name"
                      component={Input}
                      placeholder="Last Name"
                      label="Last Name"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  {/* Login */}
                  <div className="col-lg-4">
                    {!client.uid && (
                      <Field
                        type="password"
                        name="password"
                        component={Input}
                        placeholder="Password"
                        label="Password"
                        errors={errors}
                        handleChange={handleChange}
                      />
                    )}
                  </div>
                </div>
                {/* Email */}
                <div className="form-group row">
                  <div className="col-lg-4">
                    <Field
                      type="email"
                      name="email"
                      component={Input}
                      placeholder="Email"
                      label="Email"
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
     
                 
                  <div className="col-lg-4">
                    <Field
                      name="phone"
                      component={Input}
                      placeholder="Phone"
                      label="Phone"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-4">
                    {!client.uid && (
                      <Field
                        type="password"
                        name="confirm_password"
                        component={Input}
                        placeholder="Password"
                        label="Confirm Password"
                      />
                    )}
                  </div>
                </div>
                

              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={handleClose}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                onClick={() => {
                  setSubmitting(true)
                  handleSubmit()
                  setTimeout(() => setSubmitting(false), 500)

                }}
                disabled={isSubmitting}
                className="btn btn-primary btn-elevate"
              >
                {isSubmitting ?
                  <div className="d-flex align-items-center">
                    <div className="mr-2">Loading...</div>
                    <div className="spinner spinner-white mr-10"></div>
                  </div> : "Save"}
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}

export function ClientEditModal(props) {
  return (
    <>
      <Modal show={props.show} onHide={props.handleClose} size="lg">
        <Modal.Header>
          <h1>{props.client.uid ? "Edit Employee" : "New Employee"}</h1>
        </Modal.Header>

        <ClientEditForm {...props} />
      </Modal>
    </>
  );
}
export function ClienDeleteModal(props) {
  return (
    <>
      <Modal
        show={props.delete}
        onHide={props.hideDelete}
        dialogClassName="p-5"
      >
        <Modal.Header>
          <h1>Delete Employee</h1>
        </Modal.Header>
        <Modal.Body>
          Are you sure to permanently delete this <b>employee</b>?
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={props.hideDelete}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="submit"
            onClick={() => props.deleteClient(props.client.uid)}
            className="btn btn-danger btn-elevate"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}